import { useState } from "react";

import { TextToolState } from "@impero-com/ui";
import { Row } from "@tanstack/react-table";

import { useUpdateRiskDirectoryRightsForUserMutation } from "org/user/queries/useUpdateRiskDirectoryRightsForUserMutation";

import { RiskDirectoryRow } from "./useUserRiskDirectoriesListTable";

interface UseRemoveRiskDirectoryAccessRightUtilsProps {
    userId: number;
    selectedRows: Row<RiskDirectoryRow>[];
    deselectAll: () => void;
}

export function useRemoveRiskDirectoryAccessRightUtils({
    userId,
    selectedRows,
    deselectAll,
}: UseRemoveRiskDirectoryAccessRightUtilsProps) {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const { mutate, isPending, error, reset } =
        useUpdateRiskDirectoryRightsForUserMutation();

    const removeAccessRightToolState: TextToolState =
        selectedRows.length === 0 ? { type: "DISABLED" } : { type: "ENABLED" };

    const removeAccessRight = () => {
        const riskDirectoriesIds = selectedRows.map((row) => row.original.id);
        mutate(
            { userId, data: { newUserId: null, riskDirectoriesIds } },
            {
                onSuccess: () => {
                    deselectAll();
                    setIsModalOpen(false);
                },
                // On failure the modal stays open; `error` drives the notice.
            }
        );
    };

    return {
        removeAccessRightToolState,
        isRemoveAccessRightModalOpen: isModalOpen,
        removeAccessRightError: error,
        // Reset on open (not close) so the notice stays put during the close
        // animation and a stale error can't reappear next time.
        openRemoveAccessRightModal: () => {
            reset();
            setIsModalOpen(true);
        },
        closeRemoveAccessRightModal: () => setIsModalOpen(false),
        removeAccessRight,
        isRemovingAccessRight: isPending,
    };
}
